/* Holzapfel Gesamtdesign v3 (Max, 16.10.2026) – gemeinsame Funktionen fuer alle Seiten ausser Startseite.
   - Plus-Buttons [data-hz3-add] legen per /cart/add.js in den Warenkorb und oeffnen den Drawer v2
     ueber das Theme-Ereignis ajaxProduct:added (dieselbe Strecke wie der Kaufbutton).
     cart-blocking.liquid haengt sich an fetch('/cart/add') – Versandpause/Sperren greifen also auch hier.
   - Merkliste (localStorage hz3_merkliste), Herzen [data-hz3-merk], Seite [data-hz3-merkliste]
   - Filter-Sheet, "Mehr laden", Such-Reiter, FAQ-Suche */
(function () {
  'use strict';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var KEY = 'hz3_merkliste';

  function toast(html, ms) {
    var t = document.querySelector('.hz3-toast');
    if (!t) { t = document.createElement('div'); t.className = 'hz3-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = html; t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, ms || 2600);
  }
  window.hz3Toast = toast;
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- In den Warenkorb ---------- */
  function addItems(items, btn) {
    if (btn) btn.classList.add('is-busy');
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (btn) btn.classList.remove('is-busy');
      if (data && data.status && data.status >= 400) { toast(esc(data.description || 'Konnte nicht hinzugefügt werden.')); return null; }
      var product = data && data.items ? data.items[0] : data;
      if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1400); }
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: product, addToCartBtn: btn } }));
      return data;
    }).catch(function () { if (btn) btn.classList.remove('is-busy'); });
  }
  window.hz3Add = addItems;

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-hz3-add]');
    if (!b || b.tagName === 'A') return;
    e.preventDefault();
    addItems([{ id: Number(b.getAttribute('data-hz3-add')), quantity: 1 }], b);
  });

  /* ---------- Merkliste ---------- */
  function liste() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function speichern(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} malHerzen(); }
  function malHerzen() {
    var l = liste();
    document.querySelectorAll('[data-hz3-merk]').forEach(function (h) {
      var an = l.indexOf(h.getAttribute('data-hz3-merk')) !== -1;
      h.classList.toggle('is-an', an); h.setAttribute('aria-pressed', an ? 'true' : 'false');
    });
    document.querySelectorAll('[data-hz3-merk-zahl]').forEach(function (z) { z.textContent = l.length; z.hidden = !l.length; });
  }
  window.hz3Merkliste = { liste: liste, speichern: speichern };
  document.addEventListener('click', function (e) {
    var h = e.target.closest('[data-hz3-merk]');
    if (!h) return;
    e.preventDefault();
    var handle = h.getAttribute('data-hz3-merk'), l = liste(), i = l.indexOf(handle);
    if (i === -1) { l.unshift(handle); toast('Auf der Merkliste. <a href="' + ROOT + 'pages/wishlist">Ansehen</a>'); }
    else { l.splice(i, 1); toast('Von der Merkliste entfernt.'); }
    speichern(l);
    if (h.closest('[data-hz3-merkliste]')) renderMerkliste();
  });

  function eur(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function renderMerkliste() {
    var box = document.querySelector('[data-hz3-merkliste]');
    if (!box) return;
    var l = liste();
    var liste_el = box.querySelector('[data-hz3-ml-liste]'), leer = box.querySelector('[data-hz3-ml-leer]'),
        zahl = box.querySelector('[data-hz3-ml-zahl]'), bar = box.querySelector('[data-hz3-ml-bar]');
    zahl.textContent = l.length === 1 ? '1 Produkt' : l.length + ' Produkte';
    if (!l.length) { liste_el.innerHTML = ''; leer.hidden = false; bar.hidden = true; liste_el.hidden = true; return; }
    leer.hidden = true; liste_el.hidden = false;
    Promise.all(l.map(function (h) {
      return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=hz3-zeile', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (teile) {
      liste_el.innerHTML = teile.join('');
      malHerzen();
      var summe = 0, ids = [];
      liste_el.querySelectorAll('[data-hz3-ml-preis]').forEach(function (z) {
        summe += Number(z.getAttribute('data-hz3-ml-preis')); ids.push(Number(z.getAttribute('data-hz3-ml-id')));
      });
      bar.hidden = !ids.length;
      var knopf = bar.querySelector('button');
      knopf.querySelector('span').textContent = 'Alle in den Warenkorb · ' + eur(summe);
      knopf.onclick = function () { addItems(ids.map(function (id) { return { id: id, quantity: 1 }; }), knopf); };
    });
  }
  function importiere() {
    var m = new URLSearchParams(location.search).get('m');
    if (!m) return;
    var l = liste();
    m.split(',').forEach(function (h) { h = h.trim(); if (h && l.indexOf(h) === -1) l.push(h); });
    speichern(l);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-hz3-ml-teilen]');
    if (!t) return;
    var url = location.origin + ROOT + 'pages/wishlist?m=' + liste().map(encodeURIComponent).join(',');
    if (navigator.share) navigator.share({ title: 'Meine Merkliste – DER HOLZAPFEL', url: url }).catch(function () {});
    else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast('Link kopiert.'); });
  });

  /* ---------- Filter-Sheet (Kategorie) ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-hz3-sheet-auf]');
    if (o) { var s = document.getElementById(o.getAttribute('data-hz3-sheet-auf')); if (s) { s.hidden = false; requestAnimationFrame(function () { s.classList.add('is-auf'); }); document.documentElement.classList.add('hz3-lock'); } return; }
    var z = e.target.closest('[data-hz3-sheet-zu]');
    if (z) { var sh = z.closest('.hz3-sheet'); sh.classList.remove('is-auf'); document.documentElement.classList.remove('hz3-lock'); setTimeout(function () { sh.hidden = true; }, 280); }
  });

  /* ---------- Mehr laden (Kategorie) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-hz3-mehr]');
    if (!a) return;
    e.preventDefault();
    a.classList.add('is-busy');
    fetch(a.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var grid = document.querySelector('[data-hz3-grid]'), neu = doc.querySelector('[data-hz3-grid]');
      if (grid && neu) Array.prototype.forEach.call(neu.children, function (c) { grid.appendChild(c.cloneNode(true)); });
      var naechster = doc.querySelector('[data-hz3-mehr]');
      if (naechster) { a.href = naechster.href; a.classList.remove('is-busy'); } else { a.parentNode.remove(); }
      malHerzen();
    });
  });

  /* ---------- Endlos-Scrollen (Patrick 01.11.2026) ---------- */
  /* Lädt die nächste Seite automatisch, sobald der „Mehr anzeigen“-Knopf in Sichtweite kommt.
     Der Knopf bleibt als Rückfall (ohne IntersectionObserver oder bei Fehler). */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (en) {
        var a = en.target;
        if (en.isIntersecting && !a.classList.contains('is-busy')) a.click();
      });
    }, { rootMargin: '0px 0px 900px 0px' });
    function beobachte() { document.querySelectorAll('[data-hz3-mehr]').forEach(function (a) { io.observe(a); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', beobachte); else beobachte();
    /* nach jedem Nachladen erneut prüfen, falls der Knopf noch im Sichtbereich steht */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-hz3-mehr]');
      if (!a) return;
      var t = setInterval(function () {
        if (!document.body.contains(a)) { clearInterval(t); return; }
        if (!a.classList.contains('is-busy')) { clearInterval(t); io.unobserve(a); io.observe(a); }
      }, 250);
    });
  })();

  /* ---------- Reiter + Chips (Suche) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-hz3-tab]');
    if (tab) {
      var wrap = tab.closest('[data-hz3-tabs]');
      wrap.querySelectorAll('[data-hz3-tab]').forEach(function (x) { x.classList.toggle('is-on', x === tab); x.setAttribute('aria-selected', x === tab); });
      wrap.querySelectorAll('[data-hz3-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-hz3-panel') !== tab.getAttribute('data-hz3-tab'); });
      return;
    }
    var chip = e.target.closest('[data-hz3-chip]');
    if (chip) {
      var box = chip.closest('[data-hz3-chips]'), liste_el = document.querySelector(box.getAttribute('data-hz3-chips'));
      box.querySelectorAll('[data-hz3-chip]').forEach(function (x) { x.classList.toggle('is-on', x === chip); });
      var art = chip.getAttribute('data-hz3-chip'), rows = Array.prototype.slice.call(liste_el.children);
      rows.forEach(function (r) { r.hidden = art === 'frei' && r.getAttribute('data-frei') !== '1'; });
      if (art === 'preis') rows.sort(function (a, b) { return Number(a.getAttribute('data-preis')) - Number(b.getAttribute('data-preis')); });
      else rows.sort(function (a, b) { return Number(a.getAttribute('data-pos')) - Number(b.getAttribute('data-pos')); });
      rows.forEach(function (r) { liste_el.appendChild(r); });
    }
  });

  /* ---------- FAQ-Suche ---------- */
  document.addEventListener('input', function (e) {
    var f = e.target.closest('[data-hz3-faq-suche]');
    if (!f) return;
    var q = f.value.trim().toLowerCase(), treffer = 0;
    document.querySelectorAll('[data-hz3-faq] details').forEach(function (d) {
      var hit = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
      d.hidden = !hit; if (hit) treffer++;
      if (q && hit) d.open = true;
    });
    document.querySelectorAll('[data-hz3-faq] [data-hz3-faq-gruppe]').forEach(function (g) {
      g.hidden = !g.querySelector('details:not([hidden])');
    });
    var leer = document.querySelector('[data-hz3-faq-leer]'); if (leer) leer.hidden = treffer > 0;
  });

  function start() { importiere(); malHerzen(); renderMerkliste(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
